<template>
    <tr>
        <td style="text-align:center">            
            <v-select
                v-model="itemModel.subject_id"                
                :items="subjects"
                item-value="id"
                outlined
                dense
                hide-details
                @change="updateRecord"
                :disabled="!editTermReports" 
            >
                <template 
                    v-slot:selection="{item}"                                       
                >
                   <span style="font-size:0.8rem; width:40px; text-align:center">{{ item.id }}</span>
                </template>

                <template
                    v-slot:item="data"
                > 
                    {{ data.item.id}} {{ data.item.title }}
                </template>
            </v-select>
        </td>
        <td>{{ itemModel.abbr}}</td>
        <td 
            style="text-align:center"
        >
            <v-text-field
                v-model="courseMark"
                hide-details                
                type="number"
                min=0
                :max="maxCourse"
                oninput="if(Number(this.value) > this.max) this.value = this.max; else if(Number(this.value) < this.min) this.value = this.min"
                outlined
                style="font-size:0.8rem"
                @blur="updateRecord"
                disabled 
                :filled="true"
            ></v-text-field>
        </td>        
        <td 
            style="text-align:center"
        >
            <v-text-field
                v-model="itemModel.exam_mark"
                hide-details                
                type="number"
                min=0
                :max="maxExam"
                oninput="if(Number(this.value) > this.max) this.value = this.max; else if(Number(this.value) < this.min) this.value = this.min"
                outlined
                style="font-size:0.8rem"
                @blur="updateRecord"
                :disabled="!editTermReports || disableExamMark"
                :filled="filled" 
                
            ></v-text-field>
        </td>

        <td 
            style="text-align:center; max-width: 1px; white-space: nowrap;  text-overflow: ellipsis;"
        >
            <v-select
                v-model="itemModel.app1"                
                :items="grades"
                item-value="grade"
                outlined
                dense
                hide-details
                @change="updateRecord"
                :disabled="!editTermReports"
                :filled="filled" 
            >
                <template 
                    v-slot:selection="{item}"                                       
                >
                   <span style="font-size:0.8rem; width:40px; text-align:center">{{ item.grade }}</span>
                </template>

                <template
                    v-slot:item="data"
                > 
                    {{ data.item.grade }} {{ data.item.description }}
                </template>
            </v-select>  
        </td>

        <td 
            style="text-align:center; max-width: 1px; white-space: nowrap;  text-overflow: ellipsis;"
        >
            <v-select
                v-model="itemModel.con1"                
                :items="grades"
                item-value="grade"
                outlined
                dense
                hide-details
                @change="updateRecord"
                :disabled="!editTermReports"
                :filled="filled" 
            >
                <template 
                    v-slot:selection="{item}"                                       
                >
                   <span style="font-size:0.8rem; width:40px; text-align:center">{{ item.grade }}</span>
                </template>

                <template
                    v-slot:item="data"
                > 
                    {{ data.item.grade}} {{ data.item.description }}
                </template>
            </v-select>   
        </td>

        <td 
            style="max-width: 1px; white-space: nowrap;  text-overflow: ellipsis;"
        >            
            <v-select
                v-model="itemModel.coded_comment"                
                :items="codedComments1"
                item-value="id"
                outlined
                dense
                hide-details
                @change="updateRecord"
                :disabled="!editTermReports"
                :filled="filled"  
            >
                <template 
                    v-slot:selection="{item}"                                       
                >
                   <span style="font-size:0.8rem; width:40px; text-align:center">{{ item.id }}</span>
                </template>

                <template
                    v-slot:item="data"
                > 
                    {{ data.item.id}} {{ data.item.detail }}
                </template>
            </v-select>                             
        </td>

        <td 
            style="max-width: 1px; white-space: nowrap;  text-overflow: ellipsis;"
        >            
           <v-select
                v-model="itemModel.coded_comment_1"                
                :items="codedComments1"
                item-value="id"
                outlined
                dense
                hide-details
                @change="updateRecord"
                :disabled="!editTermReports"
                :filled="filled"  
            >
                <template 
                    v-slot:selection="{item}"                                       
                >
                   <span style="font-size:0.8rem; width:40px; text-align:center">{{ item.id }}</span>
                </template>

                <template
                    v-slot:item="data"
                > 
                    {{ data.item.id}} {{ data.item.detail }}
                </template>
            </v-select>                                
        </td>
        
        <td>
            <v-btn 
                icon
                @click="deleteRecord"
                :disabled="!editTermReports" 
            >
                <v-icon
                    small
                >
                    mdi-delete
                </v-icon>
            </v-btn>
        </td>        
    </tr>    
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
    props: {
        item: Object,
        formLevel: Number,
        term: Number,
        maxCourse: Number,
        maxExam: Number,
    },
    
    mounted: function () {  
        this.codedComments1 = [...this.codedComments];
        this.codedComments2 = [...this.codedComments];      
        this.setDisabledFields();
    },

    data: () => ({
        subject: null,
        disableExamMark: false,
        grades: [
            { grade: '10', description: 'Excellent'},
            { grade: '9', description: 'Very Good'},
            { grade: '8', description: 'Good'},
            { grade: '7', description: 'Fair'},
            { grade: '6', description: 'Poor'},
            { grade: '5', description: 'Unsatisfactory'},
        ],   
        readOnlyComment: true, 
        commentMenu: false, 
        codedComments1: [],
        codedComments2: [],
    }),

    watch: {
        item: {
            handler () {
                this.setDisabledFields();
            },
            deep: true
        }
    },

    computed: {
        ...mapGetters({
            subjects: 'admin/getSubjects',
            admin: 'auth/getAdmin',  
            currentTerm: 'termReports/getCurrentTerm',   
            editTermReports: 'admin/getEditTermReports', 
            deanFormClasses: 'termReports/getDeanFormClasses',
            studentRecord: 'termReports/getSelectedStudentRecord', 
            codedComments: 'termReports/getCodedComments',          
        }),

        itemModel () {
            
            return {...this.item};
        },

        filled () {
            return this.disableExamMark
        },
        courseMark () {
            return (this.itemModel.course_mark*1).toFixed(0);
        }
        
    },    

    methods: {
        ...mapActions({
            postTable2Record: 'admin/postUpdateTable2',
            getTable2Records: 'termReports/getTable2Records',
        }),

        ...mapMutations({
            setTable2Record: 'admin/setSelectedTable2Record',           
            setTable2Records: 'termReports/setEditViewTermReportsTable2Records',
            setStudentSubjects: 'termReports/setEditViewTermReportsStudentSubjects',
            setSnackbar: 'admin/setSnackbar',
            setDialogDelete: 'admin/setDialogDelete',
            setSaveStatus: 'termReports/setEditViewTermReportsSaveStatus',
            setSaving: 'termReports/setEditViewTermReportsSaving',
            setSaveError: 'termReports/setEditViewTermReportsSaveError',
            setSaved: 'termReports/setEditViewTermReportsSaved',
        }),

        setDisabledFields(){ 
            this.readOnlyComment = true;
            if(this.deanFormClasses.indexOf(this.studentRecord.class_id) !== -1){
                this.readOnlyComment = false;
            }
            
            this.disableExamMark = false;

            if(this.currentTerm == 2 && this.formLevel <= 4){
                this.disableExamMark = true; 
            }

        },

        async updateRecord () { 
            // this.overlay(true);
            // this.loading(true);
            this.setSaving(true);
            this.setSaveStatus("Updating Record");
            this.setSaved(false);
            this.setSaveError(false);

            let table2Record = Object.assign({}, this.itemModel);
            table2Record.subject_id_old = this.item.subject_id;
            table2Record.subject_id_new = this.itemModel.subject_id;
            // console.log(table2Record);
            this.setTable2Record(table2Record);
            try {
                let response = await this.postTable2Record();
                this.$emit('update-average');

                response = await this.getTable2Records();
                this.setTable2Records(response.data.table2_records);
                this.setStudentSubjects(response.data.student_subjects);

                this.setSaving(false);
                this.setSaveStatus("Record Updated");
                this.setSaved(true);
                this.setSaveError(false);

                this.setSnackbar({
                    text: `Record Updated`,
                    display: true,
                    color: 'primary',
                }); 

            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
                this.setSnackbar({
                    text: `Error occured`,
                    display: true,
                    color: 'red',
                });
                
                this.setSaving(false);
                this.setSaveStatus("Error Occured!");
                this.setSaved(false);
                this.setSaveError(true);
            }

            // this.overlay(false);
            // this.loading(false);
        },

        deleteRecord () {
            // console.log(`Delete ${this.itemModel.abbr}`);
            // console.log(this.item);
            this.setDialogDelete({
                display: true,
                text: `Delete ${this.itemModel.title} ?`,
                cancel: true,
                deleteSubject: true,
                deleteStudent: false,
                ok: false
            })            
            this.setTable2Record(this.item);
            
        },
        
    }
}
</script>

<style scoped>
    ::v-deep .v-input{
        width: 45px;
    }    

    ::v-deep .v-select__slot{
        height: 20px;
    }

    ::v-deep .v-input__icon{
        height: 5px;
        min-width: 8px;
        width: 8px;
    }

    ::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections{
        height: 20px;
        padding: 0px;
        
    }

    ::v-deep .v-input input{
        max-height: 20px;
    }

    ::v-deep .v-btn--icon.v-size--default{
        height: 20px;
        width: 20px;
    }

    ::v-deep .v-icon.v-icon.mdi-menu-down{
        display: none;
    }

    ::v-deep .v-textarea.v-text-field--enclosed.v-text-field--outlined:not(.v-input--dense) textarea{
        margin-top: 0;
        padding-bottom: 4px;
        padding-top: 4px;
       
    }



    ::v-deep .v-input.v-textarea{
        margin: 3px 0px;
    }

    ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
        padding: 0 8px;
    }

    
</style>